import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './MyFixture.scss';
import MyFixtureSummary from './MyFixtureSummary';
import MyFixtureTable from './MyFixtureTable';
import { FixtureInputSelector } from '../FixtureManagement/reducers/FixtureInputReducer';
import FixtureInput from '../FixtureManagement/FixtureInput';
import MyFixtureSearch from './MyFixtureSearch';
import { setTriggerMyFixtureSearch } from './reducers/MyFixtureSearchReducer';

const MyFixture: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const fixtureInputSelector = useSelector(FixtureInputSelector);

    useEffect(() => {
        document.title = "My Fixture";

        dispatch(setTriggerMyFixtureSearch((new Date()).getTime()));
    }, []);

    return (
        <>
            {
                fixtureInputSelector.showInputPanel &&
                <FixtureInput></FixtureInput>
            }

            <Grid container className="fixture">
                <Grid container className="fixture-search">
                    <Grid item xs={9}>
                        <MyFixtureSearch></MyFixtureSearch>
                    </Grid>
                    <Grid item xs={3}>
                        <MyFixtureSummary></MyFixtureSummary>
                    </Grid>
                </Grid>
                <Grid container className="datatable">
                    <MyFixtureTable></MyFixtureTable>
                </Grid>
            </Grid>
        </>
    )
};

export default MyFixture;